function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import styled from 'styled-components';
import PropTypes from 'prop-types';
import { strictSpace } from '../../utils';
import styledPropTypes from '@styled-system/prop-types';
/**
 * Renders a page divider with customizable margins
 */

var Divider = styled.hr.withConfig({
  displayName: "Divider",
  componentId: "sc-1d45b84-0"
})(["", " border:0;height:1px;background-color:", ";opacity:", ";"], strictSpace, function (_ref) {
  var theme = _ref.theme;
  return theme.colors.borderPrimary;
}, function (props) {
  return props.light ? 0.4 : 1;
});
Divider.propTypes = _objectSpread({
  /** For dividers on dark backgrounds */
  light: PropTypes.bool
}, styledPropTypes.space);
/** @component */

export default Divider;